<script>
import { mapGetters } from 'vuex'
import actions from './actions'
export default {
    mixins: [actions],

    computed: mapGetters({
        user: 'user',
    }),
    methods: {
        add(file) {
            this.user.attachments.push(file)
            this.save()
        },

        del(index) {
            this.user.attachments.splice(index, 1)
            this.save()
        },
    },
}
</script>

<template lang="pug">
acrm-panel
    label {{ $t('BASE.UPLOAD_ATTACHMENTS')}}
    div
        acrm-upload(@input="add")

    template(v-if="user && user.attachments && user.attachments[0]")
        label.mt-3 {{ $t('BASE.ADDED_ATTACHMENTS') }}
        table.table.table-striped.table-hover()
            thead
                tr
                    th {{ $t('BASE.FILENAME') }}
                    th {{ $t('BASE.UPLOAD_DATE') }}
                    th &nbsp;
            tbody
                tr(v-for="(file, index) in user.attachments" :key="file.id")
                    td {{ file.filename }}
                    td {{ file.created_at | toDate }}
                    td.text-right
                        a(:href="file.urls.download")
                            acrm-input-button.d-inline-flex.btn-lg.p-0(variant="link" icon="file_download")
                        acrm-input-button.d-inline-flex.btn-lg.p-0(variant="link" icon="close" @click="del(index)")
</template>
